module.exports = __webpack_public_path__ + "static/media/moedas.890af868.svg";